module.exports = __webpack_public_path__ + "img/icon-clothing.05da1ed0.svg";